// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__5YSwK","buttons":"SendReceipts_buttons__2mLDL","email":"SendReceipts_email__3_9zC","bookApptTitle":"SendReceipts_bookApptTitle__6O9Ve"};